<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}">
    <div class="position: relative;">
      <!-- .custom-company-productGroup === ccp -->
      <div class="ccp">
        <div class="ccpp-content">
          <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{Modal}}</div> -->
          <iSwitch size="large" v-model="Modal.isOpen">
            <span slot="open">开启</span>
            <span slot="close">关闭</span>
          </iSwitch>
          <a href="javascript:;" class="ccpp-link" @click="linkTo()">新建</a>
          <span class="ccp-info">点击{{ Modal.isOpen ? '关闭' : '开启'}}产品分组</span>
          <div style="padding-top: 30px;">
            <Select v-model="Modal.groupId" style="width:100%">
              <template v-if="list && list.items && list.items.length">
                <Option v-for="item in list.items" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </template>
            </Select>
          </div>
          <div class="f-tar" style="margin-top:20px;">
            <Button type="primary" @click="saveCustom()" :loading="loading">保存</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex"; 

export default {
  // 产品分组
  name: "custom-company-productGroup",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    info: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          info: "产品分组",
          type: 8,
          isOpen: true,
          title: "产品分组",
          groupId: ""
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      companyType: 0,
      visible: false,
      cityList: [
        {
          value: "New York",
          label: "New York"
        },
        {
          value: "London",
          label: "London"
        },
        {
          value: "Sydney",
          label: "Sydney"
        },
        {
          value: "Ottawa",
          label: "Ottawa"
        },
        {
          value: "Paris",
          label: "Paris"
        },
        {
          value: "Canberra",
          label: "Canberra"
        }
      ],
      model1: [],
      list: null,
      pageSize: 16,
      pageIndex: 1,
      totalCount: 0
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    },
    currentSave(val, oldVal) {
      this.loading = val;
    }
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      currentSave: "customCompanyModule/getCurrent",
      activeIndex: "customCompanyModule/getActiveIndex"
    }),
    type() {
      return this.Modal.config.type;
    },
    option() {
      return { compId: this.company.id, pageSize: 1000 };
    }
  },
  created() {
    this.getComapyType();
    this.init();
  },
  methods: {
    ...mapActions({
      getProductGroup: "productModule/getProductGroup"
    }),
    ...mapMutations({
      setCurrent: "customCompanyModule/setCurrent",
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    linkTo() {
      const link = location.origin + "/exhibition/index/proGroup/productadd";
      window.open(link);
    },
    async init() {
      let listData = await this.getProductGroup(this.option);

      if (listData && listData.items) {
        listData.items.forEach(c => {
          c.introduction = JSON.parse(c.introduction);
        });
        this.list = listData; 
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
      }
    },
    getComapyType() {
      let type = 1;
      const path = this.$route.path; 
      if (path.indexOf("service") !== 1) {
        type = 1;
      }
      if (path.indexOf("brand") !== 1) {
        type = 2;
      }
      if (path.indexOf("franchisee") !== 1) {
        type = 3;
      }
      if (path.indexOf("factory") !== 1) {
        type = 4;
      }
      this.companyType = type;
    },
    saveCustom() {
      this.setCurrent(true);
    }
  }, 
};
</script> 
<style scoped lang="scss">
.ccp {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  .ccpp {
    &-title {
      padding: 20px 30px;
      font-size: 14px;
      color: #333;
      border-bottom: solid 1px #ddd;
    }
    &-link {
      position: absolute;
      right: 20px;
      top: 20px;
    }
    &-content {
      padding: 40px 50px;
      .addlink {
        border: dashed 1px #bfbfbf;
        text-align: center;
        color: #1890ff;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
